import {ControlUpdater} from '../../dynamic-field/control-updater.type';
import {FieldConfig} from '../../dynamic-field/field.config';
import {isCommonValidatorsChanged, updateCommonFields} from '../../dynamic-field/default-control-updater';
import {buildTextFieldValidators} from './text-field.builder';
import {TextFieldConfig} from './text-field.config';

export const textFieldControlUpdater: ControlUpdater = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    updateCommonFields(currentFieldConfig, updateFieldConfig, control);

    if (isCommonValidatorsChanged(currentFieldConfig, updateFieldConfig)) {
        const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};

        const validators = buildTextFieldValidators(updatedFieldConfig);
        control.setValidators(validators);
        control.updateValueAndValidity({emitEvent: false});

        return;
    }

    if (updateFieldConfig.hasOwnProperty('minLength')
        && (currentFieldConfig as TextFieldConfig).minLength !== (updateFieldConfig as TextFieldConfig).minLength
    ) {
        setTextFieldValidators(currentFieldConfig, updateFieldConfig, control);
        control.updateValueAndValidity({emitEvent: false});

        return;
    }


    if (updateFieldConfig.hasOwnProperty('maxLength')
        && (currentFieldConfig as TextFieldConfig).maxLength !== (updateFieldConfig as TextFieldConfig).maxLength
    ) {
        setTextFieldValidators(currentFieldConfig, updateFieldConfig, control);
        control.updateValueAndValidity({emitEvent: false});

        return;
    }

    if (updateFieldConfig.hasOwnProperty('autocompleteConfig')) {
        setTextFieldValidators(currentFieldConfig, updateFieldConfig, control);
        control.updateValueAndValidity({emitEvent: false});
    }
};

export const setTextFieldValidators = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};
    const validators = buildTextFieldValidators(updatedFieldConfig);
    control.setValidators(validators);
};
